import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Tab
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';


import { FiltersOnStyle, IconHeader } from '../../../Professor/ProfessorInputGrades/css';

import ActivePollList from './ActivePollList';
import { Link } from 'react-router-dom';

import CreatedPollList from './CreatedPollList';
import ArchivedPollList from './ArchivedPollList';


export default class PollTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            statuses: [],
            loader: false,
            activeIndex: this.props.location.state?this.props.location.state.activeIndex:0
        };
    }
    componentWillMount() {
        axios.get('/questionnaire/get-statuses/')
            .then(res => {
                const statuses = res.data.map(el => ({
                    value: el.id,
                    key: el._key,
                    text: el.name
                }));
                this.setState({ statuses, loader: true });
            })
            .catch(err => {
                console.log('Failed to fetch poll statuses.');
            });
    }
componentDidMount() {
    let element = document.querySelectorAll('#myTab:nth-child(1)');

    element[0].childNodes[1].classList.remove('segment');
}

    // getStatusId(key) {
    //     console.log('trazi id statusa', key);
    //     let statusId;
    //     console.log('statusi iz state', -this.state.statuses);
    //     statusId = this.state.statuses.map((e) => e.key === key);
    //     return statusId;
    // }
    handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex })

    render() {
       

        const panes = [
            {
                menuItem: 'Aktivne ankete',
                render: () => (<Tab.Pane>
                    {this.state.loader && <ActivePollList statuses={this.state.statuses} showDetails />}
                </Tab.Pane>)
            },
            {
                menuItem: 'Kreirane ankete',
                render: () => (<Tab.Pane>
                    {this.state.loader && <CreatedPollList statuses={this.state.statuses}/>}

                </Tab.Pane>)
            },
            {
                menuItem: 'Prethodne ankete',
                render: () => (<Tab.Pane>
                    {this.state.loader && <ArchivedPollList statuses={this.state.statuses} showDetails />}

                </Tab.Pane>)
            }
        ];
        return (

            <div>

                {/* preview */}
                <Header as="h1">Ankete</Header>

                <Segment.Group raised>
                    <Segment>
                        <Header as="h3" >
                            Pregled anketa
                            <Header style={IconHeader} floated="right" >
                                {/* link */}

                                <Link to={{
                                    pathname: '/ankete/kreiranje',
                                }}
                                >
                                    <Button

                                        floated="left"
                                        icon
                                        labelPosition="right"
                                        color="blue"
                                        size="small"
                                        style={FiltersOnStyle}
                                        onClick={()=>localStorage.setItem('edit', false)}
                                    ><Icon className="add" />
                                        Kreiraj novu anketu
                                    </Button></Link>


                            </Header>
                        </Header>
                    </Segment>
                    <Segment><Tab  id="myTab"  menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} /></Segment>


                </Segment.Group>


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollTabs/PollTab.js